const duration = 7000

export const noDataProvided = {
  title: 'Oops... todos os campos são obrigatórios',
  message: 'Preenche os campos que faltam para te registares',
  type: 'danger',
  insert: 'top',
  container: window.innerWidth > 768 ? 'top-right' : 'bottom-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: duration
  }
}

export const notAgree = {
  title: 'Oops... todos os campos são obrigatórios',
  message: 'Falta leres e concordares com as nossas Políticas',
  type: 'danger',
  insert: 'top',
  container: window.innerWidth > 768 ? 'top-right' : 'bottom-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: duration
  }
}

export const alreadyExist = {
  title: 'Oops…',
  message: 'O email que estás a usar já está registado com a MUDEY',
  type: 'danger',
  insert: 'top',
  container: window.innerWidth > 768 ? 'top-right' : 'bottom-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: duration
  }
}

export const weekPassword = {
  title: 'Oops…',
  message: 'Inserir uma senha de no mínimo 6 caracteres',
  type: 'danger',
  insert: 'top',
  container: window.innerWidth > 768 ? 'top-right' : 'bottom-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: duration
  }
}

export const success = {
  title: 'Estás registado 😍na MUDEY!',
  message: 'Bem vindo(a) a nossa aplicação',
  type: 'info',
  insert: 'top',
  container: window.innerWidth > 768 ? 'top-right' : 'bottom-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: duration
  }
}
